import autobind from 'autobind-decorator'
import update from 'immutability-helper'

const CATEGORY_PUBLIC_VISIBILITY = 20;

export default class CategoryTreeHelper {

    constructor() {
        this.cnt = 1;
        this.appendCnt = 0;
        this.nodeCount = 0;
        this.indexPath = { 0:[0]};
    }

    init(rawData) {
      this.rootNode = rawData;
      this.buildNode(rawData);
    }

    @autobind
    buildNode(rawData) {
        let depth = rawData.depth;
        let opened = rawData.opened;
        let self = this;
        if (rawData.children && rawData.children.length) walk(rawData.children, rawData, depth, opened);

        function walk(children, parent, parentDepth, parentOpened) {
            const parentId = parent.id;
            const depth = parentDepth + 1;

            let indexPath = self.indexPath;
            let parentPath = indexPath[parentId];

            children.forEach((data, i) => {
                data.depth = depth;
                data.parent = parentId;
                data.priority  = i;
                data.opened = children.opened || parentOpened;
                data.updatedData = false;

                if (depth === 2) {
                  data.label = parent.name + '/' + data.name;
                }

                let path = parentPath.slice();
                path.push(i);

                indexPath[data.id] = path;
                if (data.children && data.children.length) {
                  walk(data.children, data, data.depth, data.opened);
                } else {
                  data.children = [];
                }
                self.nodeCount++;
            });
        }
    }


    @autobind
    insertBefore(movedCategoryTree, category, destId) {

        const indexPath = this.indexPath;

        let toDepth = indexPath[destId].length - 1;
        let destIndex = indexPath[destId][toDepth];

        if(toDepth === 1) {
            movedCategoryTree = update(movedCategoryTree, {
                $splice: [
                    [destIndex, 0, category],
                ]
            });

        }else if(toDepth === 2) {

            let parentIndex = indexPath[destId][toDepth - 1];

            movedCategoryTree = update(movedCategoryTree, {
                [parentIndex] : {
                    children : {
                        $splice: [[destIndex, 0, category]],
                    }
                }
            });
        }

        return this.updateNodesPosition(movedCategoryTree);
    }

    @autobind
    insertAfter(movedCategoryTree, category, destId) {

        const indexPath = this.indexPath;

        let toDepth = indexPath[destId].length - 1;
        let destIndex = indexPath[destId][toDepth];

        if(toDepth === 1) {
            movedCategoryTree = update(movedCategoryTree, {
                $splice: [
                    [destIndex + 1, 0, category],
                ]
            });

        }else if(toDepth === 2) {

            let parentIndex = indexPath[destId][toDepth - 1];

            movedCategoryTree = update(movedCategoryTree, {
                [parentIndex] : {
                    children : {
                        $splice: [[destIndex + 1, 0, category]],
                    }
                }
            });
        }

        return this.updateNodesPosition(movedCategoryTree);
    }

    @autobind
    append(categoryTree, category, destId) {

        const indexPath = this.indexPath;

        let toDepth = indexPath[destId].length - 1;
        let destIndex = indexPath[destId][toDepth];

        let appendedCategoryTree = update(categoryTree, {
            [destIndex] : {
                opened : {
                    $set : true
                },
                children : {
                    $push: [category],
                }
            }
        });

        return this.updateNodesPosition(appendedCategoryTree);
    }

    move(categoryTree, category, to, placement) {

        let movedCategoryTree = this.remove(categoryTree, category.id);

        if (placement === 'before') {
            movedCategoryTree = this.insertBefore(movedCategoryTree, category, to);
        } else if (placement === 'after') {
            movedCategoryTree = this.insertAfter(movedCategoryTree, category, to);
        } else if (placement === 'append') {
            movedCategoryTree = this.append(movedCategoryTree, category, to);
        }

        return movedCategoryTree;
    }

    prependRoot(categoryTree, category){
        let prependedCategoryTree = update(categoryTree, {
            $splice: [
                [0, 0, category],
            ]
        });
        return this.updateNodesPosition(prependedCategoryTree);
    }

    appendRoot(categoryTree, category){

        let prependedCategoryTree = update(categoryTree, {
            $push: [category]
        });
        return this.updateNodesPosition(prependedCategoryTree);
    }

    @autobind
    remove(categoryTree, categoryId) {

        let indexPath = this.indexPath;
        let fromPath = indexPath[categoryId];
        let fromDepth = indexPath[categoryId].length - 1;

        if (fromDepth === 1) {

            categoryTree = update(categoryTree, {
                $splice: [
                    [fromPath[1], 1],
                ]
            });

        }else if (fromDepth === 2) {

            categoryTree = update(categoryTree, {
                [fromPath[1]] : {
                    children : {
                        $splice: [[fromPath[2], 1]],
                    }
                },
            });
        }

        delete indexPath[categoryId];

        return this.updateNodesPosition(categoryTree);
    }


    @autobind
    rebuildNodes(children) {

        let rootNode = this.rootNode;
        rootNode.children = children;

        this.nodeCount = 0;
        this.buildNode(rootNode);

        this.appendCnt = 0;

        return rootNode.children;
    }

    rebuildChildren(children) {
      this.rootNode.children = children;
      this.buildNode(this.rootNode)
    }

    @autobind
    updateNodesPosition(children) {

        let rootNode = this.rootNode;
        let self = this;

        rootNode.children = children;
        walk(children, rootNode, rootNode.depth);

        function walk(children, parent, parentDepth) {
            const parentId = parent.id;
            const depth = parentDepth + 1;
            let indexPath = self.indexPath;
            let parentPath = indexPath[parentId];

            children.forEach((data, i) => {
                data.depth = depth;
                data.parent = parentId;
                data.priority  = i;

                if(depth === 2)
                    data.label = parent.name + '/' + data.name;

                let newPath = parentPath.slice();
                newPath.push(i);

                const oldIndexPath = indexPath[data.id];

                if(oldIndexPath && oldIndexPath.length === newPath.length && oldIndexPath.every((v,i)=> v === newPath[i])){

                }else{
                    data.updatedData = true;
                    indexPath[data.id] = newPath;
                }

                if (data.children && data.children.length) walk(data.children, data, data.depth);
                else{
                    data.children = [];
                }

            });
        }

        return children;
    }

    openCategory(categories, index) {

        return update(categories, {
            [index] : {
                opened : {
                    $set : true
                }
            }
        });
    }

    closeCategory(categories, index) {

        return update(categories, {
            [index] : {
                opened : {
                    $set : false
                }
            }
        });
    }

    openAll(categories) {

        let updateSetObj = {};
        categories.forEach((data, i) => {
            updateSetObj[i] = {
                opened : {
                    $set : true
                }
            }
        });

        return update(categories,
            updateSetObj
        );
    }

    closeAll(categories) {

        let updateSetObj = {};
        categories.forEach((data, i) => {
            updateSetObj[i] = {
                opened : {
                    $set : false
                }
            }
        });

        return update(categories,
            updateSetObj
        );
    }

    getIndex(categoryId) {
      return this.indexPath[categoryId];
    }

    updateValue(categoryTree, categoryId, label, value) {

        let indexPath = this.indexPath;

        let fromPath = indexPath[categoryId];
        let fromDepth = indexPath[categoryId].length - 1;

        if (fromDepth === 1) {
            categoryTree = update(categoryTree, {
                [fromPath[1]] : {
                  [label] : {
                        $set : value
                    }
                }
            });
        } else if (fromDepth === 2) {
            categoryTree = update(categoryTree, {
                [fromPath[1]] : {
                    children : {
                        [fromPath[2]] : {
                          [label] : {
                                $set : value
                            }
                        }
                    }
                },
            });
        }

        return categoryTree;
    }

    @autobind
    makeNew(parent) {

        let indexPath = this.indexPath;
        let depth = parent.depth + 1;
        let opened = parent.opened;
        let priority = parent.children.length + 1;

        let parentPath = indexPath[parent.id];

        const newId = ++this.appendCnt * -1 ;

        const newObj = {
            id: newId,
            name: '',
            children: [],
            depth: depth,
            opened : opened,
            priority: priority,
            visibility: CATEGORY_PUBLIC_VISIBILITY,
            parent: parent.id,
            viewChannel : null,
            entries: 0,
            categoryInfo: {},
            isNew : true
        };

        let path = parentPath.slice();
        path.push(priority);

        indexPath[newId] = path;

        return newObj;
    }

    getAppendedAndSortedCategories(categoryTree, appendedCategoryIds) {

        let appendedCategories = [];

        if(appendedCategoryIds.length === 0 )
            return appendedCategories;

        walk(categoryTree);

        function walk(children) {

            children.forEach((data) => {

                let exist = appendedCategoryIds.indexOf(data.id) !== -1;

                if(exist) {
                    appendedCategories.push(data);
                }

                if (data.children && data.children.length) walk(data.children);
            });
        }

        return appendedCategories;
    }

    getUpdatedCategories(categoryTree, updatedCategoryIds) {

        let updatedCategories = [];

        walk(categoryTree);

        function walk(children) {

            children.forEach((data) => {

                let exist = updatedCategoryIds.indexOf(data.id) !== -1;

                if(exist || data.updatedData) {
                    updatedCategories.push(data);
                }

                if (data.children && data.children.length) walk(data.children);
            });
        }
        return updatedCategories;
    }
}
